import React, { useState } from 'react'
import CardInfo from './CardInfo'
import { ListSubEstadoTable } from './ListSubEstadoTable';
import { BackButton } from '../../../../../components/buttons/ButtonDefault';

export const SubEstados = () => {
    const [reload, setReload] = useState(false);
    const [data, setData] = useState(null);
    return (
        <>
            <div className='relative'>
                <BackButton />
                <CardInfo
                    reload={reload}
                    data={data}
                    setData={setData}
                />
                <ListSubEstadoTable
                    reload={reload}
                    setReload={setReload}
                />
            </div>
        </>
    )
}
